<template>
  <div style="height:100%" class="Parameter">
    <div class="manage">
      <div class="content">
        <div class="operation">
          <el-button
            type="primary"
            :round="false"
            size="small"
            icon="el-icon-plus"
            @click="showAdd = true"
          >
            <span>添加</span>
          </el-button>
        </div>
        <div class="ParaList">
          <template>
            <el-table
              :border="true"
              :data="tableData"
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="180"
              ></el-table-column>
              <el-table-column label="参数" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.value }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 'radio'">单选框</span>
                  <span v-else-if="scope.row.type == 'text'">文本框</span>
                  <span v-else>多选框</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="Otherpage">
          <div class="changePage">
            <div @click="upPage" class="btnColor">
              <span>上一页</span>
            </div>
            <div>
              <span>{{ page }}</span>
            </div>
            <div @click="downPage" class="btnColor">
              <span>下一页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <addPara @close="closeadd" v-show="showAdd"></addPara>
    <editpara @close="closeEdit" v-show="showEdit" :row="newRow"></editpara>
  </div>
</template>

<script>
import addPara from "@/components/commodity/addPara.vue";
import editpara from "@/components/commodity/editpara.vue";
import { ParaList, delPara } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    addPara,
    editpara
  },
  data() {
    return {
      screenValue: "",
      newRow: {},
      showEdit: false,
      showAdd: false,
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      page: "1",
      tableData: []
    };
  },
  methods: {
    // 关闭页面
    closeadd(item) {
      this.showAdd = item;
      this.getParaList();
    },
    closeEdit(item) {
      this.showEdit = item;
      this.getParaList();
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.showEdit = true;
      this.newRow = row;
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
      let data = {
        token: this.token,
        id: row.id
      };
      delPara(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getParaList();
      });
    },
    // 属性列表
    getParaList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      ParaList(data).then(res => {
        console.log(res);
        this.tableData = res.data;
      });
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getParaList();
      } else {
        this.getParaList();
      }
    },
    downPage() {
      // 下
      this.page++;
      console.log(this.page);
      this.getParaList();
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message("请添加新品牌");
        this.page--;
        this.getParaList();
      }
    }
  },
  mounted() {
    this.getParaList();
  }
};
</script>

<style lang="scss" scoped>
el-table {
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
    }
    .ParaList {
      height: 100%;
      margin-top: 20px;
    }
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      left: 30px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.Parameter {
  .manage {
    .cell {
      text-align: left;
    }
  }
}
</style>
